export default "__VITE_ASSET__5e97422e__"